module.exports = __webpack_public_path__ + "static/media/MongoScrapper.f78d256b.png";